<template>
  <div class="container">
    <section class="blogs-list">
      <h2>{{ blogsList.title }}</h2>
      <div class="blogs-list_description" v-html="blogsList.description"></div>
      <div class="row">
        <BlogListItem v-for="blog in blogsList.blogs" :blog="blog" />
      </div>
      <div class="d-flex justify-content-center">
        <ButtonRed :text="blogsList.button.text" hyperlink :href="blogsList.button.link"/>
      </div>
    </section>
  </div>
</template>

<script>
import ButtonRed from '../common/ButtonRed.vue';
import BlogListItem from './BlogListItem.vue';


export default {
  props: {
    blogsList: {
      title: String,
      description: String,
      button: {
        text: String,
        link: String,
      },
      blogs: Array,
    }
  },
  components: { BlogListItem, ButtonRed }
}
</script>
